module.exports = __webpack_public_path__ + "static/media/complete-ic.aaadd3fd.svg";